import { render, staticRenderFns } from "./TasksListWidget.vue?vue&type=template&id=abc1944c&scoped=true"
import script from "./TasksListWidget.vue?vue&type=script&lang=js"
export * from "./TasksListWidget.vue?vue&type=script&lang=js"
import style0 from "./TasksListWidget.vue?vue&type=style&index=0&id=abc1944c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc1944c",
  null
  
)

export default component.exports